<template>
	
    <div class="calling">
        <div v-if="currentCall && currentCall.status=='AWAITING'" class="awaiting-connection">
            Conectando con un agente...
            <div class="loader-svg">
                <svg class="circular" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                </svg>
            </div>
        </div>

        <Video  v-if="currentCall && currentCall.status=='IN_PROGRESS'" />
        
    </div>


</template>

<script>
import Video from './Video.vue'

export default {
	name: 'Calling',
    components: {
        Video
    },
	computed:{
		currentCall: function()  {
			return this.$store.state.currentCall
		}
	},
}
</script>
<style scoped lang="scss">

.calling{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0px;
    left: 0px;

    .awaiting-connection{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 15px;
        text-align: center;
        font-weight: 500;
    }
}


.loader-svg{
	width: 150px;
	height: 150px;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: opacity 0.2s ease-in-out;

	.circular{
		width: 50px;
		height: 50px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #fff;
		position: relative;
		z-index: 99999;
		transition: all 0.2s ease-in-out;

		.path{
			stroke-dasharray: 1, 200;
			stroke-dashoffset: 0;
			transition: all 1s ease-in-out;
			-webkit-animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
			animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
			stroke-linecap: round;
			stroke-miterlimit: 10;
			stroke-width: 4px;
			stroke: #4e8cff;
		}

		@-webkit-keyframes color {
			0% {
				stroke: #4e8cff;
			}
			50% {
				stroke: #f4f7f9;
			}
			100% {
				stroke: #4e8cff;
			}
		}

		@keyframes color {
			0% {
				stroke: #4e8cff;
			}
			50% {
				stroke: #f4f7f9;
			}
			100% {
				stroke: #4e8cff;
			}
		}

		@-webkit-keyframes dash {
			0% {
				stroke-dasharray: 1, 200;
				stroke-dashoffset: 0;
			}
			50% {
				stroke-dasharray: 89, 200;
				stroke-dashoffset: -35px;
			}
			100% {
				stroke-dasharray: 89, 200;
				stroke-dashoffset: -124px;
			}
		}

	}
}
</style>
